import { Dimensions, Platform, StyleSheet } from "react-native";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import dimensions from "../../../globalStyles/dimensions";

export default StyleSheet.create({
  Wrapper: {
    flex: 1,
    backgroundColor: Colors.black100,
    // justifyContent: "center",
    alignItems: "center",
  },

  ButtonWrapper: {
    paddingHorizontal: 10,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },

  container: {
    textAlign: "center",
    height: "100%",
  },
  welcome: {
    textAlign: "center",
  },
  tophead: {
    height: 100,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // backgroundColor:"green",

    // justifyContent:'center'
    columnGap: 12,
  },
  selectGender: [GlobalStyles.heading3, GlobalStyles.black90, {}],

  optionBoxInnerBox: {
    height: 50,
    borderBottomColor: "rgba(0,0,0,0.3)",
    borderBottomWidth: 0.5,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
  },
  checkBox: {
    // backgroundColor:"rgba(192, 164, 111, 1)",
  },
  optionText: [
    {
      color: "black",
    },
  ],
  optionCircle: {
    borderWidth: 1,
    height: 25,
    width: 25,
    borderRadius: 16,
    borderColor: "#cac9c7",
  },
  optionCircleInner: {
    height: 8,
    width: 8,
    borderRadius: 7,
    backgroundColor: "white",
    zIndex: 12,
  },
  optionOnSelect: {
    backgroundColor: "rgba(192, 164, 111, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  middleScreen: {
    flex: 1
  },
  circleView: {
    height: 45,
    width: 45,
    borderRadius: 25,
    borderColor: "black",
    borderWidth: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  circleViewSmall: [
    { height: 8, width: 8, borderRadius: 7, backgroundColor: "#cac9c7" },
  ],
  circleBox: {
    // flex:1
  },
  BottomBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  buttonNext: {
    height: 75,
    width: 75,
    borderColor: "black",
    borderWidth: 1,
    borderRadius: 38,
    // backgroundColor:"#",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonNext1: {
    height: 75,
    width: 75,
    position: "absolute",
    right: 12,
    top: 650,
    borderColor: "black",
    borderWidth: 1,
    borderRadius: 38,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  arrowNext: {
    fontSize: 30,
  },
  innerBottom: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    gap: 8,
  },
  innerBottom1: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 2,
    
  },
  showOffQuestion: {
    height: "90%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  showOffBox: {
    display: "flex",
    height: "90%",
    justifyContent: "flex-end",
  },
  showOffBox1: {
    display: "flex",
    height: "96%",
    justifyContent: "flex-end",
  },
  showOffText: [
    {
      color: "white",
      paddingVertical: 12,
    },
    GlobalStyles.heading2,
  ],
  fillOut: {
    height: 60,
    backgroundColor: "black",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "white",
    borderRadius: 40,
  },
  fillOut1: {
    height: 55,
    width: "94%",
    margin: "auto",
    backgroundColor: "rgba(31, 57, 48, 1)",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "white",
    borderRadius: 27,
    marginBottom: 10,
  },
  profileButton: {
    fontSize: 16,
    color: "white",
  },
  mainImageBox: {
    display: "flex",
    // height: "74%",
  },
  imageBoxHead: [
    GlobalStyles.heading3,
    {
      fontSize: 30,
      color: "black",
      fontWeight: "600",
    },
  ],
  uploadBoxMain1: {
    display: "flex",
    marginTop: 20,
  },
  uploadBoxMain: {
    display: "flex",
    height: 230,
    marginTop: 14,
    justifyContent: "space-between",
  },
  innerUploadMain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 14,
    flexWrap: "wrap",
    width: "100%",
  },
  imageBox: {
    height: 100,
    width: 100,
    borderColor: "rgba(192, 164, 111, 1)",
    borderWidth: 1,
    borderStyle: "dashed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
  imageBox1: {
    height: 200,
    width: Dimensions.get("window").width / 2 - 20,
    // display: "flex",
    // justifyContent: "flex-start",
    // alignItems: "flex-start",
  },
  imageStyle: {
    height: "80%",
    width: "100%",
    borderRadius: 10,
  },
  uploadBottom: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  subscribeTop: {
    height: dimensions.windowHeight / 2,
    width: "100%",
    justifyContent: "center",
    backgroundColor: "green",
  },
  subscribeTopInner: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  subscribeMid: {
    height: "35%",
    // width: "100%",
    width:Platform.OS === 'web' ? 390 : "100%",
    paddingHorizontal: 20,
  },
  subscribeMidHead: [
    GlobalStyles.heading3,
    {
      color: "white",
      textAlign: "center",
      // backgroundColor:"blue",
    },
  ],
  subscribeMidHead1: [
    GlobalStyles.heading1,
    {
      color: "white",
      textAlign: "center",
      // backgroundColor:"blue",
    },
  ],
  selectConponent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 4,
    height: 46,
    width: "100%",
    borderBottomColor: "rgba(250, 250, 250, .25)",
    borderBottomWidth: 0.5,
  },
  selectConponentText: {
    fontSize: 16,
    fontWeight: "300",
    color: "white",
  },
  selectConponentCircle: {
    height: 20,
    width: 20,
    borderRadius: 13,
    // backgroundColor: "#d9d9d9"
  },
  subscribeBottom: {
    display: "flex",
    // backgroundColor:"blue",
    width: "100%",
    height: "20%",
    justifyContent: "flex-end",
  },
  subscribeBottomButton: {
    backgroundColor: "rgba(31, 57, 48, 1)",
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 25,
    margin: 6,
  },
  subscribeBottomButton1: {
    // backgroundColor:"#d9d9d9",
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 6,
  },
  LoadingText: {
    fontSize: 18,
    color: "black",
  },
  LoadingTextBox: {
    display: "flex",
    flexDirection: "row-reverse",
    width: "100%",
    // backgroundColor:"blue"
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 35,
    // backgroundColor:"green",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: "#F194FF",
  },
  buttonClose: {
    backgroundColor: "#2196F3",
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
  },
  modalBoxInner: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    // backgroundColor:"blue"
  },
  modalBox: {
    // borderWidth:2,
    width: 230,
    display: "flex",
    flexDirection: "row",
    margin: 9,
    alignItems: "center",
  },
  modelCircle: {
    borderWidth: 1,
    height: 34,
    width: 34,
    borderRadius: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 14,
  },
  backgroundImageBox: {
    width: "100%",
    // height:'60%'
  },
  backgroundImage: {
    height: "92%",
  },
  cancleButtonBox: {
    backgroundColor: "#C0A46F",
    height: 25,
    width: 25,
    position: "absolute",
    right: 6,
    top: 6,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 50,
    borderWidth: 1,
    borderColor: "white",
  },
  blurBoxText: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    //  backgroundColor:'black',
    width: 70,
    height: 70,
    borderRadius: 70,
    left: 50,
    top: 50,
    borderColor: "white",
    borderWidth: 2,
  },
  blurText: {
    fontSize: 30,
    color: "white",
  },
});
